import React from 'react';
import OrganTree from './OrganTree'
import {AppForm,AppFormItemEnum,AppFormLayout,AppAction,AppButton,AppRow} from 'qcc'
import './AppUserSelect.less'
import UserGrid from './AppUserSelectGrid'
import api, { AppOrgan } from "api";

export default class extends React.Component<{isMult?:boolean,callback?:(list?:any[])=>void}> {
	state = { organId:0 }

	handleOrganChange = (data:AppOrgan) => {
		if(this.state.organId !== data.id){
            this.setState({organId:data.id})
        }
    }

    callback = () =>{
        let list = this.refUserGrid.current.getSelected();
        let count = 0;
        if(list) count = list.length;

        if(count===0) return;

        this.props.callback && this.props.callback(list);
    }

    refUserGrid = React.createRef<UserGrid>();
    
	render() {
        let {organId} = this.state;
		return (<div className='page-user-select-container'><div className='page-user-select-inner'>
            <div className='page-user-select-content'>
                <div className='page-user-select-content-inner'>
                    <div className='page-user-content'>
                        <div className='page-user-left'>
                            <div className='page-user-organ-mune'>
                                <span>组织架构</span>
                            </div>
                            <div className='page-user-organ-content'>
                                <OrganTree showButton onClick={this.handleOrganChange}/>
                            </div>
                        </div>
                        <div className='page-user-right'>
                            <UserGrid ref={this.refUserGrid} key={organId} organId={organId} isMult={this.props.isMult}/>
                        </div>
                    </div>
                </div>
            </div>
            <div className='page-user-select-footer'>
                <AppRow>
                    <AppButton label="保存" type='primary' action={this.callback}/> 
                    <AppButton label="关闭" action={()=>{AppAction.closeDialog()}} />
                </AppRow>
            </div>
            </div></div>

	
		)
	}
}


// WEBPACK FOOTER //
// ./src/page/public/AppUserSelect.tsx